export const byKey = (keyName, arr, multipleElementsPerKey = false) => {
  return arr.reduce((red, element) => {
    const { [keyName]: key } = element;
    if (multipleElementsPerKey) {
      if (red[key] !== undefined) {
        // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
        return { ...red, [key]: [...red[key], element] };
      }
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      return { ...red, [key]: [element] };
    }
    // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
    return { ...red, [key]: element };
  }, {});
};

export const byId = (arr) => {
  return byKey('id', arr);
};
